<template>
  <div class="card-header py-3 d-md-flex justify-content-between align-items-start" :class="customClass">
    <div class="d-flex flex-column">
      <!-- Title, optionally conditional based on route -->
      <h6 class="m-0 font-weight-bold text-primary">
        <span v-if="routeNameForConditionalTitle && $route.name === routeNameForConditionalTitle">{{ conditionalTitle }}</span>
        <span v-else>{{ title }}</span>
      </h6>

      <!-- Breadcrumb -->
      <nav
        class="card-breadcrumb"
        aria-label="breadcrumb"
        style="background-color: transparent; box-shadow: none; width:auto;"
      >
        <ol class="breadcrumb mb-0 p-0" style="background-color: transparent; box-shadow: none;">
          <li
            class="breadcrumb-item"
            v-for="(item, idx) in breadcrumbItems"
            :key="idx"
            :class="{ 'breadcrumb-gray': isGrayBreadcrumb(item) }"
          >
            <router-link v-if="item.to && !isGrayBreadcrumb(item)" :to="item.to">{{ item.text }}</router-link>
            <span v-else>{{ item.text }}</span>
          </li>
        </ol>
      </nav>
    </div>

    <!-- Actions slot or default export/print buttons -->
    <div class="d-flex justify-content-end mb-2">
      <slot name="actions">
        <button
          v-if="jsonData && jsonData.length > 0"
          class="btn btn-dark btn-sm"
          @click="$emit('print', 'student_data', 'html')"
          aria-label="Print report"
        >
          <i class="fa fa-print"></i>
        </button>

        <export-excel
          v-if="jsonData && jsonData.length > 0"
          class="btn p-0 btn-sm export-btn"
          :data="jsonData"
          :name="`${excelFileName}.xls`"
          :worksheet="excelFileName"
        >
          <img src="/assets/images/excel-icon.png" alt="Export Excel" />
        </export-excel>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReportHeaderPage",
  props: {
    title: { type: String, required: true },
    breadcrumbItems: { type: Array, default: () => [] },
    jsonData: { type: Array, default: () => [] },
    excelFileName: { type: String, default: "export" },
    routeNameForConditionalTitle: { type: String, default: "" },
    conditionalTitle: { type: String, default: "" },
    customClass: { type: [String, Array, Object], default: "" },
    grayBreadcrumbTexts: { type: Array, default: () => [] } // texts to be gray in breadcrumb
  },
  methods: {
    isGrayBreadcrumb(item) {
      // check if item.text is in grayBreadcrumbTexts array
      return this.grayBreadcrumbTexts.some(
        grayText => grayText.toLowerCase() === item.text.toLowerCase()
      );
    }
  }
};
</script>

<style scoped>
.breadcrumb-gray {
  color: gray !important;
  cursor: default;
}
.breadcrumb-gray > a {
  color: gray !important;
  pointer-events: none;
  cursor: default;
}
</style>
